module.exports = __webpack_public_path__ + "fonts/01bee96.otf";